
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `ホーム画面に追加して、幅広い体験と簡単なアクセスを実現してください。`,
's224cbcec014ef6b5': `ナビゲーションバーで共有を押す`,
's37a9e8aec5713460': `展開`,
's386eca8362ff6155': `共有アイコンがない場合は「詳細」を押す`,
's4e1e10a6ca408245': `「ホーム画面に追加」をタップする`,
's6196153c4b0c1ea0': `インストール`,
's633502f7cff4f847': `ブラウザメニューを開く`,
's681e399d63311fba': `ギャラリーを表示`,
's7f0591f08e318eda': `共有メニューで「詳細」を押す`,
's8114bd55cae5a22b': `「Dockに追加」を押す`,
's922329d6f6213590': `Dockに追加`,
's9af56bf005b49c74': `「ホーム画面に追加」までスクロールする`,
'sa5ef80b4bb9b39f8': `折りたたむ`,
'sba52286c21552a4e': `デバイスにインストールすることで、より充実した体験と簡単なアクセスを実現できます。`,
'sc16e00a7a8b2fde2': `戻る`,
'scdaf4bbff76674c8': `ホーム画面に追加`,
'se0e473adfda8066c': `メインブラウザで開く`,
'se740f75b95a51807': `ドックに追加して、幅広い体験と簡単なアクセスを実現してください。`,
'sfea652f6580ff086': `このサイトはアプリ機能があります。`,
    };
  